import { SUB_DOMAIN } from '@/constants';
import { useDeviceInfoStore } from '@/stores/DeviceStore';

export const useCheckKakaobank = () =>
  useDeviceInfoStore((state) => state.subDomain === SUB_DOMAIN.KAKAOBANK);
